import { z } from 'zod';
import {
  hydrogenDirectionValues,
  hydrogenFcfsBookingStatusValues,
  hydrogenRuntimeTypeValues,
} from 'src/apis/hydrogen-fcfs/mappings';
import {
  formOptionSchema,
  getPaginationSchema,
} from 'src/components/form/zod-schemas';
import { preprocessAsArray } from 'src/components/form/zod-utilities';
import { usePageParamsFromSchema } from 'src/hooks/use-page-params-from-schema';

const schema = z.object({
  networkPointOrBundle: formOptionSchema.nullable().default(null),
  direction: z.enum(hydrogenDirectionValues).nullable().default(null),
  assignedBookingRequestId: z
    .string()
    .nullable()
    .refine(
      (value) => value === null || value.startsWith('H2FCFSR-'),
      '{label} must start with H2FCFSR-'
    )
    .default(null),
  assignedBookingId: z
    .string()
    .nullable()
    .refine(
      (value) => value === null || value.startsWith('H2FCFS-'),
      '{label} must start with H2FCFS-'
    )
    .default(null),
  runtimeTypes: z.preprocess(
    preprocessAsArray,
    z.array(z.enum(hydrogenRuntimeTypeValues)).default([])
  ),
  statuses: z.preprocess(
    preprocessAsArray,
    z
      .array(z.enum(hydrogenFcfsBookingStatusValues))
      .default([
        'CAPACITY_ORDERED',
        'BOOKED',
        'BOOKING_REJECTED',
        'PARTIALLY_CANCELLED',
        'CANCELLED',
        'ERROR',
      ])
  ),
  runtimeFrom: z.string().nullable().default(null),
  runtimeTo: z.string().nullable().default(null),
  requestedFrom: z.string().nullable().default(null),
  requestedTo: z.string().nullable().default(null),
  ...getPaginationSchema().shape,
});

export const useHydrogenShipperBookingOverviewPageParams = () => {
  return usePageParamsFromSchema(schema, {
    filters: {
      networkPointOrBundle: { label: 'Network Point' },
      direction: { label: 'Direction' },
      assignedBookingRequestId: { label: 'Booking Request ID' },
      assignedBookingId: { label: 'Booking ID' },
      runtimeTypes: { label: 'Runtime Type' },
      statuses: { label: 'Status' },
      runtimeFrom: { label: 'Runtime' },
      runtimeTo: { label: 'Runtime' },
      requestedFrom: { label: 'Time of Request' },
      requestedTo: { label: 'Time of Request' },
    },
  });
};

export type HydrogenShipperBookingOverviewPageParams = ReturnType<
  typeof useHydrogenShipperBookingOverviewPageParams
>;
